import { Injectable } from '@angular/core';

import { Entity } from 'src/app/model';

@Injectable({
  providedIn: 'root'
})
export class EntitySiteService {

  private _entityDetails: Entity;

  constructor() { }

  /**
   * Sets entity details
   * @param entityDetails 
   */
  setEntityDetails(entityDetails: Entity) {
    this._entityDetails = entityDetails;
  }

  /**
   * Gets entity details
   * @returns entity details 
   */
  getEntityDetails() {
    return this._entityDetails;
  }
}
